var qa = {
  'set-1': {
    mobile: '19f399f6-4fad-44d9-917b-fb84ec25a3fd',
    tablet: 'cbcac746-bf7c-4cf4-8322-1e34c5e7cc1b',
    desktop: '3e5acfd7-5bac-4a68-bd66-d8958e04d519'
  },
  'set-2': {
    mobile: '62d0c017-fe95-4b8c-858f-375999fd7d50',
    tablet: 'bb90d022-be0c-402a-90e1-03c4d0f905bd',
    desktop: '5fda16b8-884a-477b-9fb4-5743eb95d8fe'
  },
  'set-3': {
    mobile: 'ec22d37b-fa45-4c45-bd48-02fae71ae151',
    tablet: '4e45204b-d561-42f4-b4f0-ff8d51bb27a1',
    desktop: 'c7fb6565-c559-4170-be1d-1501e6752a4a'
  },
  'set-4': {
    mobile: 'c2fcc2d1-45f1-4d18-97da-58ccafc60cdf',
    tablet: '45bca78f-73b9-4d3a-a7e7-dfd8ace6908f',
    desktop: '5927c149-182c-4b61-ae26-6010738fa243'
  },
  'set-5': {
    mobile: '8b0e00da-291e-442e-9afd-56e1e6aeef16',
    tablet: 'e3195433-b253-47ef-bd4c-34bf5d99d571',
    desktop: 'a3f6c31f-639a-490d-80f3-eed5be79f00e'
  },
  'set-6': {
    mobile: 'b581f8b1-6996-478a-a53c-08b1855cd3b0',
    tablet: '3969e314-a8bc-47ba-b07a-7d71aeee39d2',
    desktop: 'f97776ce-3893-47c5-90d8-b301316570f8'
  },
  'set-7': {
    mobile: '12e60b49-8073-4942-b34c-a37bcdff0ec9',
    tablet: 'df8b50a6-371c-43b0-bc56-acc53c14f536',
    desktop: '8fbefb80-e390-4132-a31d-d0d9b8347567'
  }
};
var production = {
  'set-1': {
    mobile: '6fa90eee-7008-4c63-b573-7edd4de2ddb1',
    tablet: 'cf3fb41f-a3cf-4a5c-8995-38d41d0c5e2e',
    desktop: 'd024e6a8-0881-43f8-b047-12f538599cc9'
  },
  'set-2': {
    mobile: 'c6445d2e-c11e-440f-a91e-9165202cab82',
    tablet: 'f7171ffa-fdcb-4047-8ae2-3262d31a74e6',
    desktop: 'ae6db957-f0b5-43d1-bc18-53910655a9c7'
  },
  'set-3': {
    mobile: 'b7bb0951-01ef-4db9-b5b0-1feec48fde6d',
    tablet: '1bb02f89-5d9d-4f01-8db4-578115552cc4',
    desktop: '5f7cc21d-d0ef-4441-915e-45c0e4e7312f'
  },
  'set-4': {
    mobile: '77fa70f3-259f-43ee-8a77-e6492aaa2990',
    tablet: 'a62b855c-412d-40cd-83e0-efe83c9e0a3d',
    desktop: '76ff9ffb-54ee-41fd-a974-7b265a941e57'
  },
  'set-5': {
    mobile: '07e562a7-9794-4c08-9fda-9c74422dc3ca',
    tablet: '48bf0d9f-38d3-4ca7-98f1-967eefa5c0f4',
    desktop: 'ac686670-4d8b-41da-8c01-d18b445ed9d0'
  },
  'set-6': {
    mobile: '51235b65-d04e-4738-b031-0e4a83e508cb',
    tablet: '5abe0b18-ea3e-40ec-9cce-302bceac7cb8',
    desktop: '55146526-ac48-4602-ac4f-00bb57dd9502'
  },
  'set-7': {
    mobile: 'c027be83-a8fa-4f48-93c1-edec0cd745b3',
    tablet: '0b4ff331-2e93-4f64-8801-9f6a8e85c464',
    desktop: '55f57aea-2fe2-4796-b0d7-fb9d45caa5cd'
  }
};
export default (function () {
  if (process.env.UNION_MEDIA_API_ENV) {
    if (process.env.UNION_MEDIA_API_ENV !== "qa" && process.env.UNION_MEDIA_API_ENV !== "production") {
      throw new Error("Expected UNION_MEDIA_API_ENV to be 'qa' or 'production'.");
    }
    console.warn('Using UNION_MEDIA_API_ENV could result in a misconfigured environment. It is best that you use UNION_DEPLOYMENT_ENV for all your Union services integrations.');
    return process.env.UNION_MEDIA_API_ENV;
  }
  if (process.env.UNION_DEPLOYMENT_ENV) {
    if (process.env.UNION_DEPLOYMENT_ENV !== "qa" && process.env.UNION_DEPLOYMENT_ENV !== "production") {
      throw new Error("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'.");
    }
    return process.env.UNION_DEPLOYMENT_ENV;
  }
  if (false) {
    console.warn("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'. NODE_ENV fallback will be removed in a future version.");
    return process.env.NODE_ENV === 'production' ? 'production' : 'qa';
  }
  throw new Error("Expected UNION_DEPLOYMENT_ENV to be either 'qa' or 'production'.");
})() === 'production' ? production : qa;